import React, {useState, useEffect} from "react";

import {getDocuments, uploadDocument} from "../../utils/helpers";

import Loading from "../UI/Loading";
import Button from "../UI/Button";
import Modal from "../UI/Modal";
import FileUpload from "../UI/FileUpload";

import styles from "./Dashboard.module.css";

import DocumentItem from "../Documents/DocumentItem";
import DocumentDetails from "../Documents/DocumentDetails";

import {useForm} from "../Hooks/form-hook";

import {VALIDATOR_REQUIRE} from "../UI/util/validators";

const Dashboard = () => {
  const [documents, setDocuments] = useState([]);
  const [selectedDocument, setSelectedDocument] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [addDocument, setAddDocument] = useState(false);
  const [file, setFile] = useState();
  const [isFileUploaded, setIsFileUploaded] = useState({
    state: false,
    message: "",
  });

  const [uploadFormState, uploadInputHandler] = useForm(
    {
      file: {
        value: null,
        isValid: false,
      },
    },
    false
  );

  const processGetClients = async () => {
    setIsLoading(true);
    const response = await getDocuments();
    console.log(
      `[Dashboard -> Get Documents]: Response -> ${JSON.stringify(response)}`
    );
    if (response.status === 200) {
      setDocuments(response.result);
      setSelectedDocument(response.result[0]);
    } else {
      setDocuments([]);
      setSelectedDocument();
    }
    setIsLoading(false);
  };

  useEffect(() => {
    processGetClients();
  }, []);

  const selectDocumentHandler = (document) => {
    setSelectedDocument(document);
  };

  const handleAddDocument = async (event) => {
    event.preventDefault();
    uploadInputHandler("file", null, false);
    setIsFileUploaded({state: false, message: "Please wait....."});

    var reader = new FileReader();
    reader.onload = async function (e) {
      let document_type = "application/pdf";
      let document_content = reader.result.replace(
        "data:application/pdf;base64,",
        ""
      );
      await uploadDocument(
        uploadFormState.inputs.file.value.name,
        document_content,
        document_type
      );
      setFile();
      setIsFileUploaded({
        state: true,
        message: `File uploaded successfully.`,
      });

      setTimeout(() => {
        setIsFileUploaded({state: false, message: ""});
        setAddDocument(false);
      }, 3000);
    };
    reader.readAsDataURL(uploadFormState.inputs.file.value);
  };

  return (
    <div className={`${styles.Dashboard__Container}`}>
      <Modal
        show={addDocument === true}
        className={`${styles.Dashboard__Modal__Container}`}
        onCancel={() => {
          setAddDocument(false);
        }}
        header={
          <div className={`${styles.Dashboard__Modal__Header}`}>
            <h2>Add Document</h2>
          </div>
        }
        footer={
          <div className={`${styles.Dashboard__Modal__Footer}`}>
            <div className={`${styles.Dashboard__Modal__Upload__Segment}`}>
              <FileUpload
                id="file"
                onInput={uploadInputHandler}
                disabled={isFileUploaded.status}
                file={file}
                accept={[".pdf"]}
                setFileName={(filename) => setFile(filename)}
              />
            </div>
            <div
              className={`${styles.Dashboard__Modal__Upload__Segment}`}
              style={{alignItems: "center", marginBottom: "1rem"}}
            >
              {isFileUploaded.message && (
                <h6
                  style={
                    isFileUploaded.state === false
                      ? {color: "red"}
                      : {color: "green"}
                  }
                >
                  {isFileUploaded.message}
                </h6>
              )}
              {!isFileUploaded.message && <h6>&nbsp;</h6>}
            </div>

            <div
              className={`${styles.Dashboard__Modal__Footer__ButtonContainer}`}
              style={{alignItems: "center"}}
            >
              <div className={`${styles.Dashboard__Modal__Footer__Button}`}>
                <Button
                  type="submit"
                  size="quarter"
                  disabled={!uploadFormState.isValid || isFileUploaded.status}
                  onClick={handleAddDocument}
                >
                  Add File
                </Button>
              </div>
              <div className={`${styles.Dashboard__Modal__Footer__Button}`}>
                <Button
                  type="submit"
                  size="quarter"
                  variant="danger"
                  onClick={() => setAddDocument(false)}
                >
                  Cancel
                </Button>
              </div>
            </div>
          </div>
        }
      ></Modal>

      {isLoading && <Loading asOverlay />}
      {!isLoading && (
        <>
          <div className={`${styles.Dashboard__Header}`}>
            <div className={`${styles.Dashboard__Header__Button}`}>
              <img
                src="./images/refresh-icon.svg"
                style={{cursor: "pointer"}}
                onClick={() => processGetClients()}
              />
            </div>
            <div className={`${styles.Dashboard__Header__Button}`}>
              <Button onClick={() => setAddDocument(true)}>ADD DOCUMENT</Button>
            </div>
          </div>
          <div className={`${styles.Dashboard__Body}`}>
            <div className={`${styles.Dashboard__Left}`}>
              {documents.length > 0 &&
                documents.map((document) => (
                  <DocumentItem
                    document={document}
                    selectedDocument={selectedDocument}
                    onSelectDocument={selectDocumentHandler}
                  />
                ))}
            </div>
            <div className={`${styles.Dashboard__Right}`}>
              <DocumentDetails selectedDocument={selectedDocument} />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Dashboard;
